import React from 'react';
import {Route, IndexRoute, DefaultRoute, Redirect, browserHistory, Router } from 'react-router';

import App from './components/app';
import SignIn from './components/signIn';
import Container from './components/container';
import Dashboard from './components/dashboard';
import Users from './components/user/users';
import UsersEdit from './components/user/usersEdit';
import Admins from './components/admin/admins';
import AdminsEdit from './components/admin/adminsEdit';
import Language from './components/language/language_list';
import LanguageAll from './components/language/all';
import LanguageSentence from './components/language/sentence';
import LanguageSentenceAdd from './components/language/addSentence';
import LanguageLearning from './components/language/learning';
import LanguageLearningEdit from './components/language/learningEdit';
import LanguageInterface from './components/language/interface';
import LanguageInterfaceEdit from './components/language/interfaceEdit';
import LanguageAllEdit from './components/language/allEdit';
import LanguageVocabulary from './components/language/vocabulary';
import LanguageGrammar from './components/language/grammar';
import LiveSituations from './components/language/liveSituations';
import AddSituation from './components/language/addSituation';
import AddRule from './components/language/addRule';
import AddWord from './components/language/addWord';
import Chat from './components/chat/chat';
import Subscription from './components/subscription/subscription';
import Packages from './components/subscription/packages';
import PackageOne from './components/subscription/packageOne';
import PackageEdit from './components/subscription/packageEdit';
import Coupons from './components/subscription/coupons';
import CouponsEdit from './components/subscription/CouponsEdit';
import Persons from './components/chat/persons';
import PersonsEdit from './components/chat/personsEdit';
import ChatSpecial from './components/chat/chatSpecial';
import ChatSpecialAdd from './components/chat/chatSpecialAdd';
import StaticPage from './components/static_page/list';
import StaticPageEdit from './components/static_page/editPage';
import Settings from './components/settings/settings';
import NoMatch from './components/noMatch';
import EmailList from './components/email_template/list';
import EmailEdit from './components/email_template/emailEdit';
import Notifications from './components/notifications/notifications';
import NotificationAdd from './components/notifications/notificationAdd';


var someAuthCheck = function(nextState, replace) {
    if(localStorage.getItem('id_token_admin')){
        if(nextState.location.pathname == '/') {
            replace({
                pathname: '/dashboard',
                state: {nextPathname: nextState.location.pathname}
            })
        }
    }else{
        if(nextState.location.pathname != 'sign_in' || nextState.location.pathname == 'dashboard'){
            replace({
                pathname: '/sign_in',
                state: { nextPathname: nextState.location.pathname }
            })
        }
    }
};

export default (
    <Router history={browserHistory}>
        <Route path="/" onEnter={someAuthCheck} name="LLL Admin" component={App}>
            <Route components={Container}>
                <Route name="Users" path="users">
                    <IndexRoute components={Users}/>
                    <Route name="Edit user" path="edit/:id" components={UsersEdit}/>
                </Route>
                <Route name="Admins" path="admins">
                    <IndexRoute components={Admins}/>
                    <Route name="Edit admin" path="edit/:id" components={AdminsEdit}/>
                    <Route name="Add admin" path="add" components={AdminsEdit}/>
                </Route>
                <Route name="Languages" path="language">
                    <IndexRoute components={Language}/>
                    <Route name="All Languages" path="all">
                        <IndexRoute components={LanguageAll}/>
                        <Route name="Edit language" path="edit/:id" components={LanguageAllEdit}/>
                        <Route name="Add language" path="add" components={LanguageAllEdit}/>
                    </Route>
                    <Route name="Learning Languages" path="learning" >
                        <IndexRoute components={LanguageLearning}/>
                        <Route name="Edit language" path="edit/:id" components={LanguageLearningEdit}/>
                        <Route name="Sentence list" path="edit/:id/sentence" components={LanguageSentence} />
                        <Route name="Add sentence" path="edit/:id/sentence/add" components={LanguageSentenceAdd} />
                        <Route name="Add sentence" path="edit/:id/sentence/add/:id_before" components={LanguageSentenceAdd} />
                        <Route name="Edit sentence" path="edit/:id/sentence/edit/:id_sentence" components={LanguageSentenceAdd} />
                        <Route name="Vocabulary" path="edit/:id/vocabulary" components={LanguageVocabulary} />
                        <Route name="Add vocabulary word" path="edit/:id/vocabulary/add" components={AddWord} />
                        <Route name="Edit vocabulary word" path="edit/:id/vocabulary/edit/:id_word" components={AddWord} />
                        <Route name="Grammar page" path="edit/:id/grammar_page" components={LanguageGrammar} />
                        <Route name="Add rule" path="edit/:id/grammar_page/add" components={AddRule} />
                        <Route name="Edit rule" path="edit/:id/grammar_page/edit/:id_rule" components={AddRule} />
                        <Route name="Live situations" path="edit/:id/live_situations" components={LiveSituations} />
                        <Route name="Add live situation" path="edit/:id/live_situations/add" components={AddSituation} />
                        <Route name="Edit live situation" path="edit/:id/live_situations/edit/:id_situation" components={AddSituation} />
                    </Route>
                    <Route name="Interface Languages" path="interface">
                        <IndexRoute components={LanguageInterface}/>
                        <Route name="Edit language" path="edit/:id" components={LanguageInterfaceEdit}/>
                    </Route>
                </Route>
                <Route name="Chat" path="chat">
                    <IndexRoute components={Chat} />
                    <Route name="Persons" path="persons">
                        <IndexRoute components={Persons} />
                        <Route name="Add person" path="add" components={PersonsEdit}  />
                        <Route name="Edit person" path="edit/:id" components={PersonsEdit}/>
                    </Route>
                    <Route name="Chat for special events" path="special">
                        <IndexRoute components={ChatSpecial} />
                        <Route name="Add chat box" path="add" components={ChatSpecialAdd}/>
                        <Route name="Edit chat box" path="edit/:id" components={ChatSpecialAdd}/>
                    </Route>
                </Route>
                <Route name="Subscription" path="subscription">
                    <IndexRoute components={Subscription} />
                    <Route name="Packages" path="packages">
                        <IndexRoute components={Packages} />
                        <Route name="Package" path="package">
                            <IndexRoute components={PackageOne} />
                            <Route name="Add package" path="add" components={PackageEdit}  />
                            <Route name="Edit package" path="edit/:id_package" components={PackageEdit}/>
                        </Route>
                    </Route>
                    <Route name="Coupons" path="coupons">
                        <IndexRoute components={Coupons} />
                        <Route name="Add coupon" path="add" components={CouponsEdit}/>
                        <Route name="Edit coupon" path="edit/:id_coupon" components={CouponsEdit}/>
                    </Route>
                </Route>
                <Route name="Static Pages" path="static_page" >
                    <IndexRoute components={StaticPage} />
                    <Route name="Edit page" path="edit/:id_page" components={StaticPageEdit}/>
                </Route>
                <Route name="Email templates" path="email_template" >
                    <IndexRoute components={EmailList} />
                    <Route name="Edit email template" path="edit/:id_email" components={EmailEdit}/>
                </Route>
                <Route name="Notifications" path="notifications" >
                    <IndexRoute components={Notifications} />
                    <Route name="Add notification" path="add" components={NotificationAdd}/>
                    <Route name="Edit notification" path="edit/:id_notification" components={NotificationAdd}/>
                </Route>
                <Route name="Settings" path="settings" components={Settings}/>
                <Route name="Dashboard" path="/dashboard" components={Dashboard}/>
            </Route>
        </Route>
        <Route path="/sign_in" components={SignIn}/>
        <Route name="Not Found" path="*" component={NoMatch}/>
    </Router>
)



// WEBPACK FOOTER //
// ./src/routes.js